import { Sheet } from 'react-modal-sheet';
import { Button, ButtonToggle } from '@peacecover/component';
import { SparkleStar } from '@peacecover/icon';
import { useGetSceneProducts } from '../../../domains/scene/ui/hooks/useGetSceneProducts';
import { useGetUserInfo } from '../../../domains/user/ui/hooks/useGetUserInfo';
import { openNewTab } from '../../../utils/UIUtils';
import BettieAgreementSection from '../../chat/components/BettieAgreementSection';

interface CreateCastRelationshipBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

const CreateCastRelationshipBottomSheet = ({
  isOpen,
  onClose
}: CreateCastRelationshipBottomSheetProps) => {
  const { data: user } = useGetUserInfo();
  const { data: sceneProducts } = useGetSceneProducts({
    category: 'cast_relationship'
  });
  const castRelationshipTicket = sceneProducts?.[0];

  const handlePayment = () => {
    if (!castRelationshipTicket || !user) return;
    const amount = Number(castRelationshipTicket?.amount);
    const baseParams = new URLSearchParams({
      amount: String(amount),
      productName: castRelationshipTicket.name,
      productId: castRelationshipTicket.sceneProductId,
      productType: 'scene_product'
    });
    if (user?.identified) {
      openNewTab(`/payment/inicis?${baseParams.toString()}`);
    } else {
      openNewTab(`/payment/buyer-info?${baseParams.toString()}`);
    }
  };

  return (
    <Sheet isOpen={isOpen} onClose={onClose} detent="content">
      <Sheet.Container className="!rounded-t-[20px] !bg-backgroundElevated-dark !border-none">
        <Sheet.Content>
          <div className="px-[24px] py-[40px] flex flex-col items-start">
            <div className="flex items-start gap-[2px]">
              <div className="p-[2px]">
                <SparkleStar size={12} className="text-pure-white" />
              </div>
              <p className="text-[13px] font-semibold leading-[16px] text-main-dark-2">
                새로운 조합으로 변경해도, 기존 조합은 저장되어
                <br />
                언제든 다시 확인할 수 있어요
              </p>
            </div>

            <div className="w-full mt-[20px] p-[1px] rounded-[17px] bg-gradient-multi-rainbox-lv2">
              <div
                className="flex items-center justify-between p-[20px] rounded-[16px] w-full"
                style={{
                  background:
                    'linear-gradient(0deg, rgba(0, 0, 0, 0.90) 0%, rgba(0, 0, 0, 0.90) 100%), radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.00) 100%), conic-gradient(from 135deg at 50% 50%, #E5B400 0deg, #CB3AF3 102.59999871253967deg, #03D3FF 232.19999313354492deg, #E5B400 360deg)'
                }}
              >
                <div className="flex items-center gap-[6px]">
                  <ButtonToggle type="check" size="lg" checked={true} />
                  <span className="text-[15px] font-semibold text-main-dark-2 leading-[18px]">
                    {castRelationshipTicket?.name}
                  </span>
                </div>
                <span className="text-[15px] font-semibold text-main-dark-2 leading-[18px]">
                  {Number(castRelationshipTicket?.amount).toLocaleString()}원
                </span>
              </div>
            </div>
            <div className="mt-[32px] w-full">
              <BettieAgreementSection />
            </div>
          </div>
          <div className="px-[24px]">
            <Button
              size="large"
              className="w-full h-[56px] !bg-[#5D3EFA] !rounded-[18px] text-[17px] font-bold text-white"
              onClick={handlePayment}
            >
              동의하고 결제하기
            </Button>
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop className="!bg-[rgba(0,0,0,0.5)]" />
    </Sheet>
  );
};

export default CreateCastRelationshipBottomSheet;
